import { render } from "./LoadDetailModal.vue?vue&type=template&id=22bf038c&ts=true"
import script from "./LoadDetailModal.vue?vue&type=script&lang=ts"
export * from "./LoadDetailModal.vue?vue&type=script&lang=ts"

import "./LoadDetailModal.vue?vue&type=style&index=0&id=22bf038c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__